(function () {
  const gallerySelector = '.variant-gallery-grid';
  const imageSelector = '.variant-gallery-grid img';
  const modalId = 'variantImageModal';
  const modalImgId = 'variantModalImg';
  const closeClass = 'variant-modal-close';

  function ensureModalExists() {
    if (!document.getElementById(modalId)) {
      const modal = document.createElement('div');
      modal.id = modalId;
      modal.className = 'variant-modal';
      modal.innerHTML =
        '<span class="' + closeClass + '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17" width="18" height="17">' +
            '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>' +
          '</svg>' +
        '</span>' +
        '<img class="variant-modal-content" id="' + modalImgId + '">';
      document.body.appendChild(modal);
    }
  }

  function injectCSS() {
    if (document.getElementById('variant-modal-styles')) return;

    const css = `
      ${imageSelector} { cursor: pointer; pointer-events: auto; }
      .variant-modal {
        display: none; position: fixed; inset: 0; z-index: 999999;
        background: rgba(64,64,64,0.9);
        overflow-y: auto; overflow-x: hidden;
        place-items: center;
      }
      .variant-modal-content {
        background: #e6e7d8;
        padding: 2rem 11rem;
        border-radius: 0;
        max-width: 90vw;
        max-height: none;
        box-sizing: border-box;
        display: block;
      }
      .variant-modal-content[src] {
        max-width: 100%;
        height: auto;
        margin: 0 auto;
        display: block;
      }
      .variant-modal-close {
        position: fixed;
        height: 36px;
        width: 4rem;
        border-radius: 50%;
        border: 1px solid #cfcfcf;
        right: 5rem;
        top: 2rem;
        background: #e6e7d8;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.2rem;
        cursor: pointer;
        z-index: 2;
      }
      .variant-modal[style*="display: none"] { pointer-events: none; }
    `;

    const style = document.createElement('style');
    style.id = 'variant-modal-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function openModal(src) {
    const modal = document.getElementById(modalId);
    const img = document.getElementById(modalImgId);
    if (!modal || !img) return;
    img.src = src;
    modal.style.display = 'grid';
    modal.style.pointerEvents = 'auto';
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    modal.style.display = 'none';
    modal.style.pointerEvents = 'none';
    document.documentElement.style.overflow = '';
  }

  function delegatedClickHandler(e) {
    const img = e.target.closest && e.target.closest(imageSelector);
    if (img) {
      if (!img.closest(gallerySelector)) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(img.src);
      return;
    }

    if (e.target.closest && e.target.closest('.' + closeClass)) {
      closeModal();
      return;
    }

    const modal = e.target.closest && e.target.closest('#' + modalId);
    if (modal && e.target === modal) {
      closeModal();
    }
  }

  function attachHandlers() {
    document.removeEventListener('click', delegatedClickHandler, true);
    document.addEventListener('click', delegatedClickHandler, true);
    document.removeEventListener('keydown', keydownHandler);
    document.addEventListener('keydown', keydownHandler);
  }

  function keydownHandler(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeModal();
  }

  function observeMutations() {
    const container = document.querySelector(gallerySelector);
    if (!container || window._variantGalleryObserver) return;

    const obs = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('img')) {
                node.style.pointerEvents = 'auto';
                node.style.cursor = 'pointer';
              } else {
                node.querySelectorAll && node.querySelectorAll('img').forEach(i => {
                  i.style.pointerEvents = 'auto';
                  i.style.cursor = 'pointer';
                });
              }
            }
          });
        }
      }
    });

    obs.observe(container, { childList: true, subtree: true });
    window._variantGalleryObserver = obs;
  }

  function replaceExistingCloseButton() {
    const closeBtn = document.querySelector('.variant-modal-close');
    if (closeBtn && closeBtn.innerHTML.indexOf('svg') === -1) {
      closeBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
          class="icon icon-close" fill="none" viewBox="0 0 18 17" width="18" height="17">
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 
          7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546
          l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 
          10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
        </svg>
      `;
    }
  }

  function replaceVariantGalleryImages(newImages) {
    const container = document.querySelector('.variant-gallery-grid .imk');
    if (!container) return;

    container.innerHTML = '';

    newImages.forEach(src => {
      const img = document.createElement('img');
      img.src = src;
      img.width = 175;
      img.style.height = 'auto';
      img.style.pointerEvents = 'auto';
      img.style.cursor = 'pointer';
      container.appendChild(img);
    });
  }
   console.log("Script jitsh loaded");
  function loadVariantGalleryData() {
    const dataEl = document.querySelector('[id^="VariantGalleryData-"]');
    if (!dataEl) return null;

    try {
      const parsed = JSON.parse(dataEl.textContent || '{}');
      return parsed.variants || null;
    } catch (e) {
      console.error('VariantGalleryData JSON parse error', e);
      return null;
    }
  }

  function initVariantGalleryWatcher() {
    const variantsData = loadVariantGalleryData();
    if (!variantsData) return;

    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idInput) return;

    function updateFromVariantId(variantId) {
      if (!variantId) return;
      const match = variantsData.find(v => String(v.id) === String(variantId));
      const urls = match && match.gallery
        ? match.gallery.map(path => window.location.origin + '/cdn/shop/' + path)
        : [];
      replaceVariantGalleryImages(urls);
      observeMutations();
    }
    updateFromVariantId(idInput.value);

    const obs = new MutationObserver(() => {
      updateFromVariantId(idInput.value);
    });
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  function init() {
    injectCSS();
    ensureModalExists();
    replaceExistingCloseButton();
    attachHandlers();
    observeMutations();

    document.querySelectorAll(imageSelector).forEach(img => {
      img.style.pointerEvents = 'auto';
      img.style.cursor = 'pointer';
    });
    initVariantGalleryWatcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
